module.exports = __webpack_public_path__ + "static/img/logo-02.9ce4259.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/chataxera/logo-02.png
// module id = uzpz
// module chunks = 34